export const BADGE_TYPES = {
    preference: 'Préference',
    diet: 'Régime',
};
